export const AuthenticationTranslations = {
    authenticationTranslations : {
        forgotPassword : 'Forgot password',
        description: 'Enter the email you signed up with and we will send you a new password.',
        confirmation: {
            message: 'We\'ve sent a temporary password to your email address. Please check your inbox for the email titled "Password Reset".',
        }
    }
}
